import { render, staticRenderFns } from "./CalendarCompetitionItemComponent.vue?vue&type=template&id=316780c6&scoped=true"
import script from "./CalendarCompetitionItemComponent.vue?vue&type=script&lang=ts"
export * from "./CalendarCompetitionItemComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316780c6",
  null
  
)

export default component.exports